import axios from "axios";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";
import {
  ENCOUNTERS,
  LEAD_CARE_MANAGER,
  SUBMIT_ANSWER,
  SURVEY,
  SURVEY_COMMENTS,
  UPLOAD_DOCUMENT,
  TASKS,
  USERS,
} from "constants/endpoints";

import { result } from "lodash";
import { toast } from "react-toastify";
import { deleteApi, get, post, put } from "services/network";
import { getAccessToken } from "utils/common";
export const getActiveUsers = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    id: obj.id ? obj.id : "",
    status: obj.status ? obj.status : "",
    search: obj.search ? obj.search : "",
  };
  try {
    let url = `${USERS}?page=${params.page}&per=${params.perPage}&filter[status]=active`;
    if (params.search) {
      url += `&query=${encodeURIComponent(params.search)}`;
    }
    const result = await get(url, true);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "An error occurred"}
      />
    );
    console.error(error); // Log the actual error
  }
};

export const addTask = async (task) => {
  try {
    const result = await post(
      `${TASKS}`,
      {
        task: {
          ...task,
        },
      },
      true
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Task created successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
export const updateTask = async (id, task) => {
  try {
    const result = await put(
      `${TASKS}/${id}`,
      {
        task: {
          ...task,
        },
      },
      true
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Task has been successfully completed"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};

export const showSurvey = async (id, templateId = "") => {
  try {
    const result = await post(
      `${SURVEY}`,
      {
        survey_response: {
          member_id: id,
          template_id: templateId,
        },
      },
      true
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
export const getSurveyHistory = async (obj) => {
  const params = {
    status: obj.status ? obj.status : "",
    id: obj.id ? obj.id : "",
    page: obj.page ? obj.page : 1,
    per: obj.perPage ? obj.perPage : 10,
  };
  try {
    const result = await get(
      `${SURVEY}?filter[member_id]=${params.id}&filter[status]=${params.status}&page=${params.page}&per=${params.per}`,
      true
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
export const getSurveyAnswers = async (id) => {
  try {
    const result = await get(`${SURVEY}/${id}/review_answers`, true);
    return result;
  } catch (error) {
    console.log(result);
  }
};
const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
export const submitQuestion = async (id, optionId, attachment = "") => {
  let payload;
  if (attachment instanceof File) {
    // payload = {
    //   answer: {
    //     answer_type: "file",
    //     attachment: formData,
    //     selected_answer_options_attributes: {
    //       answer_option_id: null,
    //       value: optionId,
    //     },
    //   },
    // };
    // const formData = new FormData();
    // formData.append("document", attachment);
    let base64Document = null;

    if (attachment) {
      base64Document = await convertFileToBase64(attachment);
    }

    try {
      const result = await post(
        UPLOAD_DOCUMENT(id),
        // formData,
        { document: base64Document },

        true
      );
      toast(<CustomToast variant={alertTypes.INFO} message="Answer Saved" />);
      return result;
    } catch (error) {
      console.log("error", error);
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={error?.response?.data?.errors?.attachment}
        />
      );
      console.log(result);
    }
  } else if (!attachment) {
    payload = {
      answer: {
        selected_answer_options_attributes: optionId,
      },
    };

    try {
      const result = await put(`${SUBMIT_ANSWER}/${id}`, payload, true);
      toast(<CustomToast variant={alertTypes.INFO} message="Answer Saved" />);
      return result;
    } catch (error) {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={error?.response?.statusText}
        />
      );
      console.log(result);
    }
  }
};
export const submitAllQuestions = async (id) => {
  const payload = {
    survey_response: {
      status: "completed",
    },
  };
  try {
    const result = await put(`${SURVEY}/${id}`, payload, true);
    toast(<CustomToast variant={alertTypes.INFO} message="Answer Submitted" />);
    return result;
  } catch (error) {
    console.log("error?.response?.statusText", error?.response);
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={
          error?.response?.data?.errors?.error || error?.response?.statusText
        }
      />
    );
    console.log(result);
  }
};
export const submitLeadCareManager = async (id, optionId) => {
  const payload = {
    survey_response: {
      lead_care_manager_id: optionId,
    },
  };
  try {
    const result = await put(`${SURVEY}/${id}`, payload, true);
    toast(<CustomToast variant={alertTypes.INFO} message="Answer Saved" />);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
export const discardSurvey = async (id) => {
  try {
    const result = await deleteApi(`${SURVEY}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Survey deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "delete"}
      />
    );
    console.log(result);
  }
};

export const getLeadCareManagersByLocation = async (memberId) => {
  // const params = {
  //   page: obj?.page ? obj.page : 1,
  //   perPage: obj?.perPage ? obj.perPage : 10,
  //   search: obj?.search ? obj.search : '',
  //   filter: obj?.status ? obj.status : '',
  // };
  try {
    const result = await get(
      `${LEAD_CARE_MANAGER}/filter_by_member_locations?member_id=${memberId}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getSurveyComments = async (memberId) => {
  try {
    const result = await get(
      `${SURVEY_COMMENTS}?filter[commentable_type]=Member&filter[commentable_id]=${memberId}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createSurveyComment = async (memberId, content) => {
  try {
    const result = await post(
      `${SURVEY_COMMENTS}`,
      {
        comment: {
          content,
          commentable_type: "Member",
          commentable_id: memberId,
        },
      },
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const updateSurveyComment = async (commentId, content) => {
  try {
    const result = await put(
      `${SURVEY_COMMENTS}/${commentId}`,
      {
        comment: {
          content,
        },
      },
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const discardEncounter = async (id) => {
  try {
    const result = await deleteApi(`${ENCOUNTERS}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Encounter deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "delete"}
      />
    );
    console.log(result);
  }
};
